import React from 'react';
import { SvgIconProps } from '../SvgIcon/SvgIcon';

interface AccordionContextValues {
    headerId?: string;
    contentId?: string;
    expanded?: boolean;
    onToggle?: (event: React.SyntheticEvent) => void;
    variant?: 'condensed';
    transitionDuration?: { enter: number; exit: number };
    chevron?: React.ReactElement<SvgIconProps>;
}

export const AccordionContext = React.createContext<AccordionContextValues>({});

export function useAccordionContext(): AccordionContextValues {
    return React.useContext(AccordionContext);
}
